import dayjs from './dayjs'

// タイムゾーンが異なっても日本時間のカレンダーを表示させるため、react-calendarに用いる
const toCalendarDate = (date: string | dayjs.Dayjs) => {
  let dateStr = date
  if (typeof date !== 'string') {
    dateStr = date.format('YYYY-MM-DD')
  }
  return new Date(`${dateStr}T00:00:00`)
}

export default toCalendarDate
